import React, { useCallback } from 'react';
import Papa from 'papaparse';

interface CSVUploaderProps {
  onFileLoaded: (data: any[]) => void;
  onError?: (error: Error) => void;
  accept?: string;
  className?: string;
}

const CSVUploader: React.FC<CSVUploaderProps> = ({
  onFileLoaded,
  onError,
  accept = '.csv',
  className = '',
}) => {
  const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        onFileLoaded(results.data);
      },
      error: (error) => {
        if (onError) {
          onError(new Error(error.message));
        }
      },
    });
  }, [onFileLoaded, onError]);

  return (
    <input
      type="file"
      accept={accept}
      onChange={handleFileChange}
      className={`block w-full text-sm text-gray-500
        file:mr-4 file:py-2 file:px-4
        file:rounded-md file:border-0
        file:text-sm file:font-semibold
        file:bg-blue-50 file:text-blue-700
        hover:file:bg-blue-100
        ${className}`}
    />
  );
};

export default CSVUploader; 